import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Tab, Tabs, Badge, Card, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from "axios";
import { FaUserAlt, FaSearch, FaTimes, FaHistory, FaFilter, FaUsers, FaCheck, FaPaperPlane, FaMobileAlt, FaApple, FaAndroid, FaChevronDown, FaChevronRight, FaCalendarAlt, FaClock, FaBell, FaTrash, FaPause, FaPlay, FaEdit } from "react-icons/fa";
import webservice from "./../../../services/webservice";
import { FaTimeline } from 'react-icons/fa6';
import { IoIosSend, IoMdNotifications } from "react-icons/io";
import { FaSun, FaPlus } from "react-icons/fa";
import NotificationTracking from './NotificationTracking';
import { ComponentLoader } from '../common/Loader';
import "./ScheduledNotification.css"

const ScheduledNotification = () => {
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("compose");
    const [notifications, setNotifications] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [bodymessage, setMessage] = useState("");
    const [screenDestination, setScreenDestination] = useState("");
    const [dropsOfMedhorizoneBodymessage, setDropsOfMedhorizoneBodymessage] = useState("");
    const [loadingSchedules, setLoadingSchedules] = useState(false);
    const [image, setImage] = useState(null);

    const screenOptions = [
        { label: "Water Reminder", key: "waterReminder" },
        { label: "BP List View", key: "bpListview" },
        { label: "Blood Sugar List View", key: "bsListview" },
        { label: "Insurance List View", key: "insuranceListview" },
        { label: "Mental Health", key: "mentalHealth" },
        { label: "Medication", key: "medication" },
        { label: "Mood Tracker", key: "mood" },
        { label: "AI Response", key: "AIResponse" },
        { label: "Drops Of Medhorizone", key: "story" }
    ];

    // Scheduling States
    const [scheduleType, setScheduleType] = useState("one-time"); // one-time | recurring
    const [scheduledAtLocal, setScheduledAtLocal] = useState("");
    const [repeatType, setRepeatType] = useState("weekly"); // yearly | monthly | weekly
    const [daysOfWeek, setDaysOfWeek] = useState([]);
    const [status, setStatus] = useState("active");
    const [editingId, setEditingId] = useState(null);

    // Targeting Mode: 'all', 'filtered', 'specific'
    const [targetMode, setTargetMode] = useState('all');

    const renderSortHeader = (label, field, align = 'center') => {
        const [currentField, currentOrder] = schSortBy.split(':');
        const isActive = currentField === field;

        return (
            <th
                className={align === 'start' ? 'ps-4' : 'text-center'}
                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                onClick={() => {
                    if (isActive) {
                        setSchSortBy(`${field}:${currentOrder === 'asc' ? 'desc' : 'asc'}`);
                    } else {
                        setSchSortBy(`${field}:desc`);
                    }
                }}
            >
                <div className={`d-flex align-items-center ${align === 'start' ? '' : 'justify-content-center'} gap-2`}>
                    {label}
                    <div className="d-flex flex-column align-items-center" style={{ fontSize: '10px', lineHeight: '10px' }}>
                        <FaChevronDown style={{ opacity: isActive && currentOrder === 'asc' ? 1 : 0.3, transform: 'rotate(180deg)' }} />
                        <FaChevronDown style={{ opacity: isActive && currentOrder === 'desc' ? 1 : 0.3 }} />
                    </div>
                </div>
            </th>
        );
    };

    // Filters
    const [filters, setFilters] = useState({
        age: "",
        ageRange: "",
        gender: "",
        maritalStatus: "",
        city: "",
        country: "",
        userType: ""
    });

    // Specific Users
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    const [notificationSent, setNotificationSent] = useState(false);

    const [pagination, setPagination] = useState({
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        perPage: 10
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [goToPage, setGoToPage] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    // Date Range State (Default: Start=Today, End=Last 7 Days)
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    const [dateRange, setDateRange] = useState({
        startDate: sevenDaysAgo.toISOString().split('T')[0],
        endDate: todayStr
    });
    // Expanded Row State
    const [expandedRow, setExpandedRow] = useState(null);
    const lastSchedulesFetchRef = useRef(null);

    // Active Schedules Filters
    const [schFilterTitle, setSchFilterTitle] = useState("");
    const [schFilterScheduleType, setSchFilterScheduleType] = useState("All");
    const [schFilterStartDate, setSchFilterStartDate] = useState("");
    const [schFilterEndDate, setSchFilterEndDate] = useState("");
    const [schFilterTarget, setSchFilterTarget] = useState("All");
    const [schFilterStatus, setSchFilterStatus] = useState("All");
    const [schSortBy, setSchSortBy] = useState("createdAt:desc");

    // Debounce Active Schedules Search
    const [schDebouncedTitle, setSchDebouncedTitle] = useState("");
    useEffect(() => {
        const timer = setTimeout(() => {
            setSchDebouncedTitle(schFilterTitle);
        }, 500);
        return () => clearTimeout(timer);
    }, [schFilterTitle]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchTerm);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    // Fetch history when tab is active or pagination/search/date changes
    // useEffect(() => {
    //     if (activeTab === 'history') {
    //         fetchHistory();
    //     }
    // }, [activeTab, currentPage, itemsPerPage, debouncedSearch, dateRange, dateRange.startDate,
    //     dateRange.endDate]);

    // const fetchHistory = async () => {
    //     try {

    //         // Construct query params
    //         const queryParams = new URLSearchParams({
    //             page: currentPage,
    //             limit: itemsPerPage,
    //             search: debouncedSearch,
    //             startDate: dateRange.startDate,
    //             endDate: dateRange.endDate
    //         });

    //         const response = await axios.post(webservice + 'api/get-notifications?' + queryParams);
    //         const result = await response.data;

    //         if (result.success) {
    //             setNotifications(result.data);
    //             if (result.pagination) {
    //                 setPagination(result.pagination);
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Error fetching history:", error);
    //     }
    // };

    // Fetch schedules
    useEffect(() => {
        if (activeTab === 'schedules') {
            const timer = setTimeout(() => {
                fetchSchedules(currentPage);
            }, 400);
            return () => clearTimeout(timer);
        }
    }, [activeTab, currentPage, itemsPerPage, schDebouncedTitle, schFilterScheduleType, schFilterStartDate, schFilterEndDate, schFilterTarget, schFilterStatus, schSortBy]);

    const fetchSchedules = async (page = 1) => {
        try {
            setLoadingSchedules(true);
            const queryParams = new URLSearchParams({
                page: page,
                limit: itemsPerPage,
                title: schDebouncedTitle,
                scheduleType: schFilterScheduleType,
                startDate: schFilterStartDate,
                endDate: schFilterEndDate,
                target: schFilterTarget,
                status: schFilterStatus,
            });
            const [currentField, currentOrder] = schSortBy.split(':');
            queryParams.append('sortBy', currentField);
            queryParams.append('sortOrder', currentOrder);

            const response = await axios.post(webservice + 'api/get-scheduler-notifications?' + queryParams.toString());
            if (response.data.success) {
                setSchedules(response.data.data);
                if (response.data.pagination) {
                    setPagination(response.data.pagination);
                }
            }
        } catch (error) {
            console.error("Error fetching schedules:", error);
        } finally {
            setLoadingSchedules(false);
        }
    };

    // Pagination Logic for Schedules (Updated to use server response)
    // Server returns pre-paginated data, so we don't slice it.
    const currentSchedules = schedules;
    const totalPages = pagination.totalPages;

    const handleGoToPage = (e) => {
        e.preventDefault();
        const pageNum = parseInt(goToPage);
        if (isNaN(pageNum) || pageNum < 1 || pageNum > totalPages) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Page',
                text: `Please enter a valid page number between 1 and ${totalPages}`,
                confirmButtonColor: '#27ae60'
            });
            setGoToPage("");
        } else {
            setCurrentPage(pageNum);
            setGoToPage("");
        }
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => {
            const next = { ...prev, [key]: value };
            if (key === 'age') next.ageRange = value;
            if (key === 'ageRange') next.age = value;
            return next;
        });
    };

    const handleSaveSchedule = async (e) => {
        e.preventDefault();

        // Basic validation
        if (!scheduledAtLocal) {
            Swal.fire("Error", "Please select scheduled date and time.", "error");
            return;
        }

        const actualBody = (screenDestination === "story" && dropsOfMedhorizoneBodymessage)
            ? dropsOfMedhorizoneBodymessage
            : bodymessage;

        const payload = {
            _id: editingId,
            title,
            subTitle,
            body: actualBody,
            bodymessage,
            dropsOfMedhorizoneBodymessage,
            screenDestination,
            imageUrl: image,
            notificationType: screenDestination === "story" ? "morning" : "schedule",
            scheduleType,
            scheduledAt: new Date(scheduledAtLocal).toISOString(),
            target: targetMode,
            filters: targetMode === 'filtered' ? filters : {},
            status,
            lastSentAt: null,
        };

        try {
            const response = await axios.post(webservice + 'api/save-scheduler-notification', payload);
            if (response.data.success) {
                Swal.fire("Success", response.data.message, "success");
                resetForm();
                setActiveTab("schedules");
            }
        } catch (error) {
            console.error("Error saving schedule:", error);
            Swal.fire("Error", "Failed to save schedule.", "error");
        }
    };

    const resetForm = () => {
        setTitle("");
        setSubTitle("");
        setMessage("");
        setImage(null);
        setDropsOfMedhorizoneBodymessage("");
        setScreenDestination("");
        setScheduleType("one-time");
        setScheduledAtLocal("");
        setTargetMode("all");
        setEditingId(null);
        setFilters({
            age: "",
            ageRange: "",
            gender: "",
            maritalStatus: "",
            city: "",
            country: "",
            userType: ""
        });
    };

    const handleEdit = (item) => {
        setEditingId(item._id);
        setTitle(item.title || "");
        setSubTitle(item.subTitle || "");
        setScreenDestination(item.screenDestination || "");
        setDropsOfMedhorizoneBodymessage(item.dropsOfMedhorizoneBodymessage || "");
        setMessage(item.bodymessage || item.body || "");
        setImage(item.imageUrl || null);
        setScheduleType(item.scheduleType);
        if (item.scheduledAt) {
            const dateObj = new Date(item.scheduledAt);
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getDate()).padStart(2, '0');
            const hours = String(dateObj.getHours()).padStart(2, '0');
            const minutes = String(dateObj.getMinutes()).padStart(2, '0');
            setScheduledAtLocal(`${year}-${month}-${day}T${hours}:${minutes}`);
        } else {
            setScheduledAtLocal("");
        }
        setTargetMode(item.target);
        if (item.target === 'filtered') {
            setFilters(item.filters || {
                age: "",
                ageRange: "",
                gender: "",
                maritalStatus: "",
                city: "",
                country: "",
                userType: ""
            });
        }
        setActiveTab("compose");
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d63031',
            cancelButtonColor: '#636e72',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.delete(webservice + `api/delete-scheduler-notification/${id}`);
                if (response.data.success) {
                    Swal.fire("Deleted!", "Schedule has been deleted.", "success");
                    fetchSchedules();
                }
            } catch (error) {
                console.error("Error deleting schedule:", error);
            }
        }
    };

    const toggleStatus = async (item) => {
        const newStatus = item.status === 'active' ? 'paused' : 'active';
        try {
            const response = await axios.patch(webservice + `api/update-scheduler-status/${item._id}`, { status: newStatus });
            if (response.data.success) {
                fetchSchedules();
            }
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    return (
        <>
            <div className='notification-wrapper'>
                <div className='col-lg-12 col-xl-12 col-xxl-12'>
                    <div className='fade-in'>
                        <div className='form-section-card' style={{ padding: '24px 24px', marginTop: '20px', marginBottom: '20px', marginLeft: "23.5px", marginRight: "24px" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>

                                <div style={{ display: "flex", gap: "10px" }}>
                                    <div
                                        onClick={() => navigate('/notification')}
                                        className="nav-tab-btn"
                                    >
                                        Compose notification
                                    </div>
                                    <div
                                        onClick={() => navigate('/scheduled-notification')}
                                        className="nav-tab-btn active"
                                    >
                                        Scheduled Notification
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='header-actions mb-4'>
                    <div className="custom-tabs-container">
                        <button className={`tab-btn ${activeTab === "compose" ? "active" : ""}`}
                            onClick={() => setActiveTab("compose")}>
                            <FaPlus /> {editingId ? "Edit Schedule" : "Create Schedule"}
                        </button>
                        <button className={`tab-btn ${activeTab === "schedules" ? "active" : ""}`}
                            onClick={() => setActiveTab("schedules")}>
                            <FaCalendarAlt /> Active Schedules
                        </button>
                    </div>
                </div>

                <div className="notify-content-area">
                    {activeTab === "compose" && (
                        <div className="fade-in">
                            <form onSubmit={handleSaveSchedule}>
                                {/* Section 1: Notification Content */}
                                <div className="form-section-card">
                                    <div className="section-header">
                                            <div className="icon-circle">
                                                <FaBell />
                                            </div>
                                            <div className="section-title-group">
                                                <h4>Notification Content</h4>
                                            </div>
                                        <div className="header-status-toggle">
                                            <span className={`status-label-badge ${status}`}>{status}</span>
                                            <label className="custom-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={status === 'active'}
                                                    onChange={(e) => setStatus(e.target.checked ? 'active' : 'paused')}
                                                />
                                                <span className="slider"></span>
                                            </label>
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-4">
                                            <label className="modern-label">Select Category</label>
                                            <select
                                                value={screenDestination}
                                                onChange={(e) => setScreenDestination(e.target.value)}
                                                className="modern-select"
                                                required
                                            >
                                                <option value="">-- Select Category --</option>
                                                {screenOptions.map((option) => (
                                                    <option key={option.key} value={option.key}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-12 mb-4">
                                            <label className="modern-label">Campaign Title</label>
                                            <input
                                                type="text"
                                                value={title}
                                                maxLength={screenDestination === 'story' ? undefined : 100}
                                                onChange={(e) => setTitle(e.target.value)}
                                                placeholder="Enter Title"
                                                className="modern-input"
                                                required
                                            />
                                        </div>

                                        {screenDestination === 'story' && (
                                            <div className="col-md-12 mb-4">
                                                <label className="modern-label">Campaign Sub Title</label>
                                                <input
                                                    type="text"
                                                    value={subTitle}
                                                    maxLength={150}
                                                    onChange={(e) => setSubTitle(e.target.value)}
                                                    placeholder="Enter Sub Title"
                                                    className="modern-input"
                                                    required
                                                />
                                            </div>
                                        )}

                                        {screenDestination !== 'story' && (
                                            <div className="col-md-12 mb-4">
                                                <label className="modern-label">Notification Body</label>
                                                <textarea
                                                    rows={2}
                                                    value={bodymessage}
                                                    maxLength={200}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    placeholder="Write your engaging message here..."
                                                    className="modern-textarea"
                                                    required
                                                ></textarea>
                                            </div>
                                        )}

                                        {screenDestination === 'story' && (
                                            <div className="col-md-12 mb-4">
                                                <label className="modern-label">Drops of Medhorizone Body</label>
                                                <textarea
                                                    rows={4}
                                                    value={dropsOfMedhorizoneBodymessage}
                                                    onChange={(e) => setDropsOfMedhorizoneBodymessage(e.target.value)}
                                                    placeholder="Write your engaging message here..."
                                                    className="modern-textarea"
                                                    required
                                                ></textarea>
                                            </div>
                                        )}

                                        <div className="col-md-12 mb-2">
                                            <label className="modern-label">Image Upload</label>
                                            <input type="file" accept="image/*" className="modern-input" onChange={(e) => setImage(e.target.files[0])} />
                                        </div>
                                    </div>
                                </div>

                                {/* Section 2: Audience Selection */}
                                <div className="form-section-card">
                                    <div className="section-header">
                                        <div className="icon-circle">
                                            <FaUsers />
                                        </div>
                                        <div className="section-title-group">
                                            <h4>Users Selection</h4>
                                            <p>Who should receive this notification?</p>
                                        </div>
                                    </div>

                                    <div className="radio-group">
                                        <label className="custom-radio">
                                            <input type="radio" name="targetMode" checked={targetMode === 'all'} onChange={() => setTargetMode('all')} />
                                            <span className="radio-circle"></span>
                                            All Users
                                        </label>
                                        <label className="custom-radio">
                                            <input type="radio" name="targetMode" checked={targetMode === 'filtered'} onChange={() => setTargetMode('filtered')} />
                                            <span className="radio-circle"></span>
                                            Filtered Users
                                        </label>
                                    </div>

                                    {targetMode === 'filtered' && (
                                        <div className="filters-container slide-down pt-3">
                                            <hr className="mb-4" />
                                            <div className="filters-horizontal-row">
                                                {/* Age */}
                                                <div className="filter-group-item">
                                                    <label className="modern-label">Age</label>
                                                    <select className="modern-select compact" value={filters.age || filters.ageRange || ""} onChange={(e) => handleFilterChange('age', e.target.value)}>
                                                        <option value="">All</option>
                                                        {['0-18', '19-25', '26-35', '36-45', '46-60', 'Above 60'].map(age => (
                                                            <option key={age} value={age}>{age}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Gender */}
                                                <div className="filter-group-item">
                                                    <label className="modern-label">Gender</label>
                                                    <select className="modern-select compact" value={filters.gender} onChange={(e) => handleFilterChange('gender', e.target.value)}>
                                                        <option value="">All</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Others">Others</option>
                                                    </select>
                                                </div>

                                                {/* Marital Status */}
                                                <div className="filter-group-item">
                                                    <label className="modern-label">Marital Status</label>
                                                    <select className="modern-select compact" value={filters.maritalStatus} onChange={(e) => handleFilterChange('maritalStatus', e.target.value)}>
                                                        <option value="">All</option>
                                                        {['Single', 'Married', 'Widowed', 'Divorced', 'Others'].map(status => (
                                                            <option key={status} value={status}>{status}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Section 3: Scheduling */}
                                <div className="form-section-card">
                                    <div className="section-header">
                                        <div className="icon-circle">
                                            <FaClock />
                                        </div>
                                        <div className="section-title-group">
                                            <h4>Scheduling</h4>
                                            <p>When should this be sent?</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", gap: "10px", justifyContent: "space-between", alignItems: "center" }}>
                                        <div className="radio-group mb-4">
                                            <label className="custom-radio">
                                                <input type="radio" name="scheduleType" checked={scheduleType === 'one-time'} onChange={() => setScheduleType('one-time')} />
                                                <span className="radio-circle"></span>
                                                One-time
                                            </label>
                                            <label className="custom-radio">
                                                <input type="radio" name="scheduleType" checked={scheduleType === 'recurring'} onChange={() => setScheduleType('recurring')} />
                                                <span className="radio-circle"></span>
                                                Recurring
                                            </label>
                                        </div>

                                        <div className="row slide-down">
                                            <div className="col-md-12 mb-3">
                                                <label className="modern-label">Scheduled Date & Time</label>
                                                <div className="input-with-icon">
                                                    <FaCalendarAlt className="input-icon" />
                                                    <input
                                                        type="datetime-local"
                                                        value={scheduledAtLocal}
                                                        onChange={(e) => setScheduledAtLocal(e.target.value)}
                                                        className="modern-input"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="notify-form-footer">
                                    <button type="button" className="btn-cancel" onClick={resetForm}>
                                        <FaTimes /> Cancel
                                    </button>
                                    <button type="submit" className="btn-save">
                                        <FaPaperPlane /> Save Schedule
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {activeTab === "schedules" && (
                        <div className="schedules-card fade-in">
                            <div className="pq-filter-container" style={{ padding: '20px', margin: '20px 20px 20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                <Row className="g-3 align-items-center">
                                    <div className="col-md-2">
                                        <input type="text" placeholder="Search by title..." value={schFilterTitle} onChange={(e) => setSchFilterTitle(e.target.value)} className="pq-filter-input form-control" style={{ width: '100%' }} />
                                    </div>
                                    <div className="col-md-2">
                                        <select value={schFilterScheduleType} onChange={(e) => setSchFilterScheduleType(e.target.value)} className="pq-filter-input form-control" style={{ width: '100%' }}>
                                            <option value="All">All Schedules</option>
                                            <option value="one-time">One-time</option>
                                            <option value="recurring">Recurring</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type={schFilterStartDate ? "date" : "text"}
                                            placeholder="Start Date"
                                            value={schFilterStartDate}
                                            max={schFilterEndDate}
                                            onChange={(e) => setSchFilterStartDate(e.target.value)}
                                            onFocus={(e) => (e.target.type = "date")}
                                            onBlur={(e) => (!e.target.value ? (e.target.type = "text") : null)}
                                            className="pq-filter-input form-control"
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type={schFilterEndDate ? "date" : "text"}
                                            placeholder="End Date"
                                            value={schFilterEndDate}
                                            min={schFilterStartDate}
                                            onChange={(e) => setSchFilterEndDate(e.target.value)}
                                            onFocus={(e) => (e.target.type = "date")}
                                            onBlur={(e) => (!e.target.value ? (e.target.type = "text") : null)}
                                            className="pq-filter-input form-control"
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                    <div className="col-md-1">
                                        <select value={schFilterTarget} onChange={(e) => setSchFilterTarget(e.target.value)} className="pq-filter-input form-control" style={{ width: '100%', padding: '0 5px' }}>
                                            <option value="All">All Users</option>
                                            <option value="filtered">Filtered</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select value={schFilterStatus} onChange={(e) => setSchFilterStatus(e.target.value)} className="pq-filter-input form-control" style={{ width: '100%' }}>
                                            <option value="All">All Status</option>
                                            <option value="active">Active</option>
                                            <option value="paused">Paused</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>
                                    {(schFilterTitle || schFilterScheduleType !== 'All' || schFilterStartDate || schFilterEndDate || schFilterTarget !== 'All' || schFilterStatus !== 'All') && (
                                        <div className="col-md-1">
                                            <button onClick={() => {
                                                setSchFilterTitle("");
                                                setSchFilterScheduleType("All");
                                                setSchFilterStartDate("");
                                                setSchFilterEndDate("");
                                                setSchFilterTarget("All");
                                                setSchFilterStatus("All");
                                                setSchSortBy("createdAt:desc");
                                            }} style={{ height: '36px', padding: '0 10px', backgroundColor: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', width: '100%' }}>
                                                CLEAR
                                            </button>
                                        </div>
                                    )}
                                </Row>
                            </div>

                            <div className="card-header-activeSchedule" style={{ marginBottom: '15px' }}>
                                <h3>Active Schedules</h3>
                            </div>

                            <div className="schedule-list">
                                {schedules.length > 0 ? (
                                    <div className="pq-table-wrapper">
                                        <div className="pq-table-scroll">
                                            <table className="pq-table">
                                                <thead>
                                                    <tr>
                                                        {renderSortHeader('Title', 'title', 'start')}
                                                        <th>Schedule</th>
                                                        {renderSortHeader('Next Trigger', 'scheduledAt')}
                                                        <th>Target</th>
                                                        <th>Status</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loadingSchedules ? (
                                                        <tr>
                                                            <td colSpan="6" style={{ padding: '80px 0' }}>
                                                                <ComponentLoader color="#6d77d3ff" size="40px" />
                                                            </td>
                                                        </tr>
                                                    ) : currentSchedules.map((item) => (
                                                        <tr key={item._id}>
                                                            <td>
                                                                <div className="schedule-title-cell">
                                                                    <strong>{item.title}</strong>
                                                                    {item.screenDestination && (
                                                                        <div style={{ marginTop: '4px' }}>
                                                                            <span className="badge badge-sm" style={{ fontSize: '11px', backgroundColor: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe', padding: '2px 8px', borderRadius: '4px' }}>
                                                                                {screenOptions.find(o => o.key === item.screenDestination)?.label || item.screenDestination}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Badge bg="info">
                                                                    {item.scheduleType}
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                <div className="trigger-cell">
                                                                    {item.scheduledAt ? (
                                                                        <>
                                                                            <FaCalendarAlt /> {new Date(item.scheduledAt).toLocaleDateString()}
                                                                            <br />
                                                                            <FaClock /> {new Date(item.scheduledAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <FaClock /> {item.sendTime}
                                                                            {item.sendDate && <span><br /><FaCalendarAlt /> {item.sendDate}</span>}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Badge bg="secondary">{item.target}</Badge>
                                                            </td>
                                                            <td>
                                                                <div className={`status-toggle ${item.status}`} onClick={() => toggleStatus(item)}>
                                                                    {item.status === 'active' ? <FaPlay /> : item.status === 'completed' ? <FaCheck /> : <FaPause />}
                                                                    <span>{item.status}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="action-buttons">
                                                                    <button className="edit-btn" onClick={() => handleEdit(item)}><FaEdit /></button>
                                                                    <button className="delete-btn" onClick={() => handleDelete(item._id)}><FaTrash /></button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination Controls */}
                                        <div className="pagination-music" style={{ padding: '10px 0', borderTop: '1px solid #eaeaea' }}>
                                            <div className="d-flex align-items-center mb-3 mb-md-0">
                                                <span className="pagination-info me-2">
                                                    Showing {pagination.totalCount > 0 ? ((currentPage - 1) * itemsPerPage) + 1 : 0} - {Math.min(currentPage * itemsPerPage, pagination.totalCount)} of {pagination.totalCount} Schedules. Per page:
                                                </span>
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={(e) => {
                                                        setItemsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                    className="form-select"
                                                    style={{
                                                        width: '60px',
                                                        display: 'inline-block',
                                                        marginLeft: '10px',
                                                        padding: '2px 15px 2px 8px',
                                                        fontSize: '13px',
                                                        height: '30px',
                                                        minHeight: '30px',
                                                        backgroundColor: '#eef2ff',
                                                        color: '#4f46e5',
                                                        border: '1px solid #c7d2fe',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontWeight: '600'
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>
                                            <div className="pagination-buttons">
                                                <button
                                                    className="page-btn"
                                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                    disabled={currentPage === 1}
                                                >
                                                    ◀
                                                </button>

                                                {[...Array(totalPages)].map((_, i) => (
                                                    <button
                                                        key={i + 1}
                                                        className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                                                        onClick={() => setCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                ))}

                                                <button
                                                    className="page-btn"
                                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                    disabled={currentPage === totalPages || totalPages === 0}
                                                >
                                                    ▶
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="empty-state p-5 text-center">
                                        <FaBell size={48} style={{ opacity: 0.2 }} />
                                        <p className="mt-3">No scheduled notifications found.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default ScheduledNotification